import { Skeleton, Stack, styled, Typography } from '@mui/material';

import ButtonSkeleton from '../../../../../components/Button/skeleton';
import CheckboxSkeleton from '../../../../../components/FormControls/Checkbox/Skeleton';
import SwitchSkeleton from '../../../../../components/FormControls/Switch/Skeleton';
import DurationCellSkeleton from './DurationCell/Skeleton';
import StudentResponsesSkeleton from './StudentResponses/Skeleton';
import { Cell, CellLabel, CellValue, SectionTitle, SwitchHelperText } from './styles';

const StyledCheckboxSkeleton = styled(CheckboxSkeleton)(() => ({
  marginRight: 'auto',
}));

export const EditPublishPreferencesDrawerFooterSkeleton = () => {
  return (
    <>
      <StyledCheckboxSkeleton />
      <ButtonSkeleton variant="text" />
      <ButtonSkeleton />
    </>
  );
};

const EditPublishPreferencesDrawerSkeleton = () => {
  return (
    <Stack gap={8}>
      <Stack gap={6}>
        <Cell>
          <CellLabel>
            <Skeleton variant="text" width={100} />
          </CellLabel>
          <CellValue>
            <Skeleton variant="text" width={200} />
          </CellValue>
        </Cell>
        <Cell>
          <CellLabel>
            <Skeleton variant="text" width={100} />
          </CellLabel>
          <CellValue>
            <Skeleton variant="text" width={100} />
          </CellValue>
        </Cell>
        <StudentResponsesSkeleton />
        <DurationCellSkeleton />
      </Stack>

      <Stack gap={3}>
        <SectionTitle>
          <Skeleton variant="text" width={100} />
        </SectionTitle>
        <div>
          <Stack direction="row" justifyContent="space-between" alignItems="center" gap={5}>
            <Typography variant="h6Bold">
              <Skeleton variant="text" width={200} />
            </Typography>
            <SwitchSkeleton />
          </Stack>
          <SwitchHelperText>
            <Skeleton variant="text" width="90%" />
            <Skeleton variant="text" width="60%" />
          </SwitchHelperText>
        </div>
        <div>
          <Stack direction="row" justifyContent="space-between" alignItems="center" gap={5}>
            <Typography variant="h6Bold">
              <Skeleton variant="text" width={200} />
            </Typography>
            <SwitchSkeleton />
          </Stack>
          <SwitchHelperText>
            <Skeleton variant="text" width="90%" />
            <Skeleton variant="text" width="60%" />
          </SwitchHelperText>
        </div>
        <div>
          <Stack direction="row" justifyContent="space-between" alignItems="center" gap={5}>
            <Typography variant="h6Bold">
              <Skeleton variant="text" width={200} />
            </Typography>
            <SwitchSkeleton />
          </Stack>
          <SwitchHelperText>
            <Skeleton variant="text" width="90%" />
            <Skeleton variant="text" width="60%" />
          </SwitchHelperText>
        </div>
        <Stack direction="row" justifyContent="space-between" alignItems="center" gap={5}>
          <Typography variant="h6Bold">
            <Skeleton variant="text" width={200} />
          </Typography>
          <SwitchSkeleton />
        </Stack>
      </Stack>

      <Stack gap={3}>
        <SectionTitle variant="h5Bold">
          <Skeleton variant="text" width={100} />
        </SectionTitle>
        <div>
          <Stack direction="row" justifyContent="space-between" alignItems="center" gap={5}>
            <Typography variant="h6Bold">
              <Skeleton variant="text" width={200} />
            </Typography>
            <SwitchSkeleton />
          </Stack>
          <SwitchHelperText>
            <Skeleton variant="text" width="90%" />
            <Skeleton variant="text" width="60%" />
          </SwitchHelperText>
        </div>
      </Stack>
    </Stack>
  );
};

export default EditPublishPreferencesDrawerSkeleton;
